import React, { FC } from 'react'
import styled from 'styled-components'
import { Text } from 'ui'

const ToastContainer = styled.div<{ type: 'success' | 'fail' }>`
  display: flex;
  padding: 16px 24px;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  background: ${props => props.type === 'success' ? '#E8F5E9' : '#FFEBEE'};
  border: 1px solid ${props => props.type === 'success' ? '#4CAF50' : '#F44336'};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

const IconWrapper = styled.div<{ type: 'success' | 'fail' }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${props => props.type === 'success' ? '#4CAF50' : '#F44336'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: bold;
`

interface ToastProps {
  type: 'success' | 'fail'
  title: string
}

const Toast: FC<ToastProps> = ({ type, title }) => {
  return (
    <ToastContainer type={type}>
      <IconWrapper type={type}>
        {type === 'success' ? '✓' : '✕'}
      </IconWrapper>
      <Text size="md" weight="normal" style={{ color: type === 'success' ? '#2E7D32' : '#C62828' }}>
        {title}
      </Text>
    </ToastContainer>
  )
}

export default Toast
